function toggleChevron(detailsId) {
  const details = document.getElementById(detailsId);
  const summary = details.querySelector('summary');
  const icon = summary.querySelector('svg');
  if (details.hasAttribute('open')) {
    icon.style.transform = 'rotate(0deg)';
  } else {
    icon.style.transform = 'rotate(180deg)';
  }
}


window.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.hubspot-newsletter-form form');
  const emailInput = document.querySelector('.hubspot-newsletter-form input[name="email"]');
  const submitButton = document.querySelector('.hubspot-newsletter-form .submit-button');
  const successFormContent = document.querySelector('.hubspot-newsletter-form .newsletter-form__message--success')
  const formContent = document.querySelector('.hubspot-newsletter-form');
  const errorMessage = document.getElementById('ContactFooter-error');
  submitButton.disabled = true;
  function validateForm() {
    const isEmailFilled = emailInput.value.trim() !== '';
    submitButton.disabled = !isEmailFilled;
  }
  validateForm();
  emailInput.addEventListener('input', validateForm);

  function resetForm() {
    submitButton.innerHTML = 'Enviar';
    submitButton.disabled = false;
    emailInput.value = '';
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    submitButton.innerHTML = '<span class="loader"></span>';
    submitButton.disabled = true;

    const formData = {
      email: emailInput.value.trim(),
    };

    try {
      const response = await fetch(
        'https://api.hsforms.com/submissions/v3/integration/submit/40224670/462c8ffe-a7b1-4554-9e75-d97cac80d95c',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            fields: [
              { name: 'email', value: formData.email },
              { name: 'contact__general__business_unit', value: 'Grupo' },
            ],
            context: {
              pageUri: window.location.href,
              pageName: document.title,
            },
            legalConsentOptions: {
              consent: {
                consentToProcess: true,
                text: 'Eu concordo em permitir o processamento de meus dados.',
                communications: [
                  {
                    value: true,
                    subscriptionTypeId: 688400108,
                    text: 'Aceito receber comunicações sobre novidades e promoções.',
                  },
                ],
              },
            },
          }),
        }
      );

      if (response.ok) {
        successFormContent.classList.remove('hidden');
        console.log("Response Ok")
        localStorage.setItem('sentform', 'Yes');
      }else{
        errorMessage.remove('hidden');
      }
    } catch (error) {
      errorMessage.remove('hidden');
      console.log(error);
    }

    resetForm();
  });
});